export const projectName = "Careveli";
export const themeColor = "#f23636";

const DEFAULT_API_ORIGIN = "https://api.careveli.com";
const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();

export const API_URL = configuredApiUrl
  ? (configuredApiUrl.endsWith("/") ? configuredApiUrl : `${configuredApiUrl}/`)
  : `${DEFAULT_API_ORIGIN}/api/`;

export const BASE_URL = API_URL.replace(/\/api\/?$/, "/");
export const STORE_FRONT_URL = process.env.REACT_APP_STORE_URL || "https://www.careveli.com";

export const SHIPCLUES_DEFAULTS = {
    packageLength: "14.5",
    packageBreadth: "15",
    packageHeight: "8.5",
    packageWeightGm: "60.00",
    gstRate: "18.00",
};
// export const API_URL = "http://localhost:8088/api/";
// export const BASE_URL = "http://localhost:8088/";

/**
 * Normalize image input to a string path/URL
 * @param {string|object|Array} imageInput - Image path from API
 * @returns {string} Normalized image path or URL
 */
const normalizeImagePath = (imageInput) => {
    if (!imageInput) return '';

    let path = imageInput;

    if (Array.isArray(path)) {
        path = path[0];
    }

    if (path && typeof path === 'object') {
        path = path.url || path.path || path.src || path.image || path.secure_url || '';
    }

    if (typeof path !== 'string') {
        return path ? String(path) : '';
    }

    return path.trim();
};

/**
 * Get full image URL from relative or absolute path
 * @param {string|object|Array} imagePath - Image path from API
 * @returns {string} Full image URL
 */
export const getImageUrl = (imagePath) => {
    const path = normalizeImagePath(imagePath);

    if (!path) return '';

    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    return `${BASE_URL}${path.startsWith('/') ? path : '/' + path}`;
};
